<div class="modal-header">
  <h4 class="modal-title h5" translate>Delete machine</h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div [innerHTML]="deleteMachineMessageBody"></div>
  <hr/>
  <div
      class="alert alert-info mb-0"
      [innerHTML]="deleteMessageWarning">
  </div>
</div>
<div class="modal-footer">
  <div class="modal-footer-inner">
    <div class="row align-items-center flex-fill">
      <div class="col">

      </div>
      <div class="col-auto">
        <button (click)="onCancel()" class="btn btn-outline-primary mr-2" type="button">
          <span translate>Cancel</span>
        </button>
        <button class="btn btn-primary" type="button" (click)="onDelete()">
          <span translate>Delete</span>
        </button>
      </div>
    </div>
  </div>
</div>